import { Box } from "@mui/material";
import ScoreButton from "./scoreButton";
import { PLAYER } from "../types/players";
import styled from "@mui/styled-engine";

interface ScoreButtonGroupProps {
  number: number;
  multiples: number;
  player: PLAYER;
  disabled?: boolean;
  onClickHandler: Function;
  setButtonHeight?: Function;
  mobileButtons?: boolean;
}

export default function ScoreButtonGroup({
  number,
  multiples = 1,
  player,
  disabled = false,
  onClickHandler,
  setButtonHeight,
  mobileButtons = false,
}: ScoreButtonGroupProps) {
  const gridTemplateColumns = "1fr ".repeat(multiples).trim();

  const buttons = () => {
    const scoreButtons: JSX.Element[] = [];
    for (let i = 1; i <= multiples; i++) {
      scoreButtons.push(
        <ScoreButton
          player={player}
          key={`${number}_${i}`}
          disabled={disabled}
          number={number}
          multiplier={i}
          onClickHandler={onClickHandler}
          setButtonHeight={setButtonHeight}
          mobileButtons={mobileButtons}
        />
      );
    }
    return scoreButtons;
  };

  return (
    <Wrapper display="grid" gridTemplateColumns={gridTemplateColumns}>
      {buttons()}
    </Wrapper>
  );
}

const Wrapper = styled(Box)({
  height: "100%",
  width: "100%",
  paddingTop: ".5%",
  // paddingBottom: ".5%",
  gap: "8px",
  "@media(max-width: 650px)": { gap: "5px" },
});
